import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ProductSelect from './ProductSelect';

const LineItemRow = ({ model, options, index }) => {
  const [currentQuantity, setQuantity] = useState(model.quantity);
  const [currentName, setName] = useState(model.product);
  const [currentPrice, setPrice] = useState(model.price);

  const [selectedProduct, setProduct] = useState({ label: model.p_code, value: model.p_code, data: {} } || { label: '', value: '' });

  const setInputs = (product) => {
    setName(product.data.name);
    setPrice(product.data.price);
    setProduct(product);
  }

  return (
    <fieldset className="row">
        <div className="col-xs-2">
            <input className="form-control" type="number" name={(index !== null) && `invoice[lineitems_attributes][${index}][quantity]`}
              value={currentQuantity || ''} onChange={(event) => { setQuantity(event.target.value)}}
            />
        </div>
        <div className="col-xs-3">
          <ProductSelect
              handleChange={setInputs}
              index={index}
              options={options}
              selectedValue={selectedProduct}
              showCheckbox={true}
              placeholderText='Select product'
          />
        </div>
        <div className="col-xs-5">
          <input className="form-control" type="text" name={(index !== null) && `invoice[lineitems_attributes][${index}][product]`}
              value={currentName || ''} onChange={(event) => { setName(event.target.value)}}
          />
        </div>
        <div className="col-xs-2">
          <input className="form-control" type="number" name={(index !== null) && `invoice[lineitems_attributes][${index}][price]`}
            value={currentPrice || ''} onChange={(event) => { setPrice(event.target.value)}}
          />
        </div>
    </fieldset>
  );
};

LineItemRow.propTypes = {
  model: PropTypes.object,
  options: PropTypes.array,
  index: PropTypes.number
};

LineItemRow.defaultProps = {
  model: { quantity: 0, p_code: '', product: '', price: 0 },
  options: [{}],
  index: 0
};

export default LineItemRow;
